<div fxFlex="100" fxLayout="row wrap" fxLayoutAlign="start center">
    <div class="margin-combo-commande" fxFlex="49" fxFlex.lt-md="100">
        <mat-form-field appearance="outline">
            <mat-label>{{label}} <span *ngIf="required(control)" style="color: red">*</span></mat-label>

            <mat-select #select (selectionChange)="change($event) " [formControl]="control" [multiple]="muliple"
                        disableOptionCentering>

                <ng-container *ngIf="select.focused">
                    <mat-option *ngFor="let c of listsearch" [value]="c.coCommonCdId">
                        {{getlang() == 'fr' ? c.cdNmFr : getlang() == 'ar' ? c.cdNmAr : c.cdNm}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="!select.focused">
                    <mat-option *ngFor="let c of list" [value]="c.coCommonCdId">
                        {{getlang() == 'fr' ? c.cdNmFr : getlang() == 'ar' ? c.cdNmAr : c.cdNm}}
                    </mat-option>
                </ng-container>
            </mat-select>
            <mat-error [control]="control" appControlError></mat-error>
            <button (click)="clear($event)" *ngIf="control.value" aria-label="Clear" mat-button mat-icon-button
                    matSuffix
                    type="button">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </div>

    <div fxFlex="49.4" fxFlex.lt-md="100">
        <mat-form-field appearance="outline">
            <mat-label translate>{{labelFils}} <span *ngIf="requiredFils(controlFils)" style="color: red">*</span>
            </mat-label>

            <mat-select #selectFils (selectionChange)="changeFils($event) " [disabled]='disabled' [formControl]="controlFils"
                        [multiple]="muliple" disableOptionCentering>

                <ng-container>
                    <mat-select-filter (filteredReturn)="listsearchFils = $event"
                                       *ngIf="selectFils.focused"
                                       [array]="listFils"
                                       [displayMember]="'motcle'"
                                       [noResultsMessage]="'empty_list' | translate"
                                       [placeholder]="'search' | translate"
                                       [showSpinner]="true"
                    >

                    </mat-select-filter>


                </ng-container>
                <ng-container *ngIf="selectFils.focused">
                    <mat-option *ngFor="let cc of listsearchFils" [value]="cc.coCommonCdId">
                        {{getlang() == 'fr' ? cc.cdNmFr : getlang() == 'ar' ? cc.cdNmAr : cc.cdNm}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="!selectFils.focused">
                    <mat-option *ngFor="let cc of listFils" [value]="cc.coCommonCdId">
                        {{getlang() == 'fr' ? cc.cdNmFr : getlang() == 'ar' ? cc.cdNmAr : cc.cdNm}}
                    </mat-option>
                </ng-container>
            </mat-select>
            <mat-error [control]="controlFils" appControlError></mat-error>
            <button (click)="clearFils($event)" *ngIf="controlFils.value" aria-label="Clear" mat-button mat-icon-button
                    matSuffix
                    type="button">
                <mat-icon style="color: red;">close</mat-icon>
            </button>
        </mat-form-field>

    </div>

</div>
